import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { AlertService } from 'src/app/services/alert';
import { Alert } from 'src/app/services/alert.model';


@Component({
  selector: 'app-alert-list',
imports: [CommonModule, MatIconModule, MatButtonModule],
  templateUrl: './alert.html',
  styleUrl: './alert.scss'
})
export class AlertListComponent {
  alerts: Alert[] = [];

  constructor(private alertService: AlertService) {
    this.alertService.alerts$.subscribe(alerts => (this.alerts = alerts));
  }

  onAnimationEnd(alert: Alert, event: AnimationEvent): void {
    if (alert.closing && event.animationName === 'fadeOut') {
      this.alertService.remove(alert.id);
    }
  }

  dismiss(alert: Alert): void {
    this.alertService.close(alert.id);
  }
}
